import { GridModel } from "common/models/utility-models/list-utility.model";
import { CompiledReportsModel } from "./compiled-data-model";

export class CompiledReportsGridModel extends CompiledReportsModel { }

export class CompiledReportsListingModel extends GridModel<CompiledReportsModel> {
    filterData: any;
}